import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { useStoreInfo } from "@/lib/store";

function LegalPage({ k, testid, vars = {} }) {
  const { t } = useI18n();
  const sections = t(`legal.${k}_sections`);
  return (
    <div className="container-x py-12 max-w-3xl space-y-8" data-testid={testid}>
      <div className="space-y-2">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{t(`legal.${k}_title`)}</h1>
        <p className="muted">{t("legal.intro", vars)}</p>
      </div>
      {Array.isArray(sections) && sections.map(([h, ...lines]) => (
        <section key={h} className="card p-6 space-y-3">
          <h2 className="text-xl font-semibold">{h}</h2>
          <ul className="space-y-2 text-sm leading-relaxed list-disc ps-5">{lines.map((l) => <li key={l}>{Object.entries(vars).reduce((s, [a, b]) => s.replaceAll(`{${a}}`, b), l)}</li>)}</ul>
        </section>
      ))}
      <p className="text-sm muted">{t("legal.contact_us")} <Link to="/support" className="underline">{t("footer.customer_support")}</Link></p>
    </div>
  );
}

function useVars() {
  const { pick } = useI18n();
  const s = useStoreInfo();
  return {
    name: pick(s?.business_name) || s?.store_name || "ONEX", brand: s?.store_name || "ONEX",
    taxpayer: s?.taxpayer_name || "—", tin: s?.tin || "—", address: pick(s?.address) || "—",
    cr: s?.cr_number || "—", vat: s?.vat_number || "—", email: s?.support_email || "—",
    min: s?.shipping?.eta_days_min ?? "—", max: s?.shipping?.eta_days_max ?? "—",
    fee: s ? s.shipping.flat_fee / 100 : "—", free: s ? s.shipping.free_threshold / 100 : "—",
  };
}

export const Privacy = () => <LegalPage k="privacy" testid="privacy-page" vars={useVars()} />;
export const Terms = () => <LegalPage k="terms" testid="terms-page" vars={useVars()} />;
export const ShippingPolicy = () => <LegalPage k="shipping" testid="shipping-policy-page" vars={useVars()} />;
